<script lang="ts">
  import DropdownList from '$shared/atoms/DropdownList/DropdownList.svelte';
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import { IconType } from '$shared/constants/IconType';
  import Button from '$shared/atoms/Button/Button.svelte';
  import { ButtonStyle } from '$shared/constants/ButtonStyle';
  import type { ButtonDropdownOption } from '$shared/components/types';

  interface Props {
    loading?: boolean;
    disabled?: boolean;
    options?: ButtonDropdownOption;
    onclick?: (e: MouseEvent) => void;
    onclickitem?: (detail: CommonList) => void;
    children?: import('svelte').Snippet;
  }

  let {
    loading = false,
    disabled = false,
    options = {} as ButtonDropdownOption,
    onclick,
    onclickitem,
    children
  }: Props = $props();

  let parent: HTMLElement = $state();
  let active = $state(false);

  const onClickWindow = (e: any): void => {
    if (parent && !parent.contains(e.target)) {
      active = false;
    }
  };

  const onClickIcon = (): void => {
    active = !active;
  };

  const onClickList = (detail: CommonList): void => {
    active = false;
    onclickitem?.(detail);
  };
</script>

<svelte:window onmouseup={onClickWindow} />

<div
  bind:this={parent}
  class="comp-button-dropdown"
  class:maxWidth={options?.maxWidth}
  data-cy="dropdown"
>
  <div class="buttons">
    <Button
      name={options?.name}
      {loading}
      {disabled}
      icon={options?.icon}
      style={ButtonStyle.Secondary}
      {onclick}
    >
      {@render children?.()}
    </Button>
    <div class="dropdown-action" class:disabled>
      <div class="dropdown-button">
        <Icon
          name={`${options?.name}-i`}
          {disabled}
          type={IconType.Button}
          value="icon-chevron-down"
          onclick={onClickIcon}
        />
      </div>
    </div>
  </div>
  {#if active}
    <div class="list">
      <DropdownList list={options?.list} onclick={onClickList} />
    </div>
  {/if}
</div>

<style>
  .comp-button-dropdown {
    position: relative;
  }
  .comp-button-dropdown .buttons {
    display: flex;
  }
  .comp-button-dropdown :global(.comp-button) {
    border-radius: 5px 0px 0px 5px;
  }
  .dropdown-action {
    border-style: solid;
    background-color: #fff;
    border-color: rgba(0, 0, 0, 0.15);
    border-radius: 0px 5px 5px 0px;
    height: 30px;
    border-width: 1px;
  }
  .dropdown-action.disabled {
    color: #fff !important;
    background-color: var(--grey-light) !important;
    border-color: rgba(0, 0, 0, 0.05) !important;
    cursor: not-allowed;
  }
  .dropdown-button {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .list {
    position: absolute;
    width: auto;
    transform: translate(0, 8px);
    z-index: 99;
  }
</style>
